<template>
  <div class="my-no-message-box">
    <div class="tc-100"></div>
    <div class="my-no-message-inner-img-box">
      <img src="../../../assets/img/noMessage/no-message0.png" alt="">
    </div>
    <div class="my-no-message-inner-font">购物车为空哦</div>
  </div>
</template>
<script>
// <Title1></Title1>
export default {
  name: 'NoMessage0',
  mixins: [],
  extends: {},
  props: {},
  data () {
    return {}
  },
  computed: {},
  components: {},
  filter: {},
  watch: {},
  methods: {},
  created () {
  },
  mounted () {}
}
</script>

<style lang="scss" rel="stylesheet/scss" scoped>
// @media  screen and (min-width:1218px){}
// @media  screen and (max-width:1217px){}
// @media  screen and (max-width:992px){}

.my-no-message-box{
  width: 1200px;
  height: 383px;
  background: #fff;
  margin: 0 auto;
  .my-no-message-inner-img-box{
    width: 226px;
    height: 146px;
    margin: 0 auto;
    >img{
      width: 100%;
      height: 100%;
    }
  }
  .my-no-message-inner-font{
    text-align: center;
    width: 100%;
    height: 57px;
    line-height: 57px;
    font-size:16px;
    font-weight:400;
    color:rgba(102,102,102,1);
  }
}
</style>
